import { render } from "./MoneyPage.vue?vue&type=template&id=11b1a56e&scoped=true"
import script from "./MoneyPage.vue?vue&type=script&lang=js"
export * from "./MoneyPage.vue?vue&type=script&lang=js"

import "./MoneyPage.vue?vue&type=style&index=0&id=11b1a56e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b1a56e"]])

export default __exports__